export const streetTypes = [
    'ABBEY',
    'ACRES',
    'ALLEE',
    'ALLEY',
    'AUT',
    'AV',
    'AVE',
    'BAY',
    'BEACH',
    'BEND',
    'BLVD',
    'BOUL',
    'BOURNE',
    'BYWAY',
    'C',
    'CAMPUS',
    'CAPE',
    'CAR',
    'CARREF',
    'CDS',
    'CERCLE',
    'CH',
    'CHASE',
    'CIR',
    'CIRCT',
    'CLOSE',
    'COMMON',
    'CONC',
    'COTE',
    'COUR',
    'COVE',
    'CRES',
    'CRNRS',
    'CROIS',
    'CROSS',
    'CRT',
    'CTR',
    'DALE',
    'DELL',
    'DIVERS',
    'DOWNS',
    'DR',
    'ECH',
    'END',
    'ESPL',
    'ESTATE',
    'EXTEN',
    'FIELD',
    'FOREST',
    'GATE',
    'GDNS',
    'GLEN',
    'GREEN',
    'GRNDS',
    'GROVE',
    'HARBR',
    'HILL',
    'HOLLOW',
    'HTS',
    'HWY',
    'ILE',
    'ISLAND',
    'KEY',
    'KNOLL',
    'LANDNG',
    'LANE',
    'LINE',
    'LINK',
    'LOOP',
    'MALL',
    'MANOR',
    'MEADOW',
    'MEWS',
    'ORCH',
    'PARADE',
    'PARC',
    'PASS',
    'PATH',
    'PINES',
    'PK',
    'PKY',
    'PL',
    'PLACE', 
    'PLAZA',
    'PORT',
    'PROM',
    'PT',
    'PTWAY',
    'PVT',
    'QUAY',
    'RANG', 
    'RD',
    'RDPT',
    'RG',
    'RIDGE',
    'RISE',
    'RLE', 
    'ROW',
    'RTE',
    'RUE',
    'RUN',
    'SENT',
    'SQ',
    'ST',
    'SUBDIV',
    'TERR',
    'TLINE',
    'TOWERS',
    'TRAIL',
    'VALE',
    'VIA',
    'VIEW',
    'VILLGE',
    'VISTA',
    'WALK',
    'WAY', 
    'WHARF',
    'WOOD'
  ]